import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { formatCollectionAndFieldName } from './common/common_utils';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class SupabaseCollectionList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    supaBaseData: {},
  };

  async componentDidMount() {
    const { projectId, version, dbUuid } = this.props.match.params;
    const { actions } = this.props;
    await actions.getSupabaseExternalDb({ version, projectId, dbUuid });
    const { supabaseStoredData } = this.props.dataConnector;
    if (supabaseStoredData) {
      this.setState({ supaBaseData: supabaseStoredData });
    }
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
  }
  handleContinueButtonClick = () => {
    const { history } = this.props;
    const { projectId, version } = this.props.match.params;
    const { supabaseExternalData } = this.props.location.state;
    const { supaBaseData } = this.state;
    const { uuid } = supaBaseData;
    history.push(`/data-connector/${version}/v/${projectId}/supabase-schema/${uuid}`, {
      supabaseExternalData,
    });
  };

  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };
  renderCollectionCards = (item, index) => {
    const { collectionList } = this.props.dataConnector;
    const name = item.name;
    const matchingObject = collectionList.find(
      (obj) => obj.collectionName === formatCollectionAndFieldName(name),
    );
    return (
      <span className={`card  ml-4 col-lg-4 d-flex`} key={index}>
        <div className="card-body">
          <div className="avatar__meta">
            {matchingObject ? (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name} <i className={'wb webconnect-check-circle text-success'}></i>
              </h5>
            ) : (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name}
              </h5>
            )}

            <p>Number of fields: {Object.keys(item.fields).length}</p>
            {matchingObject ? (
              <div>
                <p>Created At: {this.formatDate(new Date(matchingObject.createdAt))}</p>
                <p>Updated At: {this.formatDate(new Date(matchingObject.updatedAt))}</p>
              </div>
            ) : (
              <div>
                <p>Created At: Not yet created</p>
                <p>Updated At: Not yet updated</p>
              </div>
            )}
          </div>
        </div>
      </span>
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { getSupabaseExternalDbPending } = this.props.dataConnector;
    const { supaBaseData } = this.state;
    const { completeData } = supaBaseData;
    const tables = completeData ? completeData.tables : [];
    if (getSupabaseExternalDbPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader loading={getSupabaseExternalDbPending} size="20px" color="#303453" />
          </div>
        </CommonPageComponent>
      );
    }
    return (
      <CommonPageComponent>
        <ParentContentCard title={' List of Collections via Supabase'} icon={'collection'}>
          <div className="d-flex flex-wrap">
            {tables &&
              tables.map((item, index) => {
                return this.renderCollectionCards(item, index);
              })}
          </div>
          {tables && tables.length > 0 && (
            <div className="card-footer flex-end">
              <button
                className="btn btn-theme-submit mt-3 float-right"
                onClick={this.handleContinueButtonClick}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Continue&nbsp;
              </button>
            </div>
          )}
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupabaseCollectionList);
